<template>
  <div class="component-content sub-content">
    <div class="list-title">
      <label class="label-name">所属公司：</label>
      <el-select size="mini" :disabled="noSelectOrganization" class="organization-select" v-model="form.depId"
        placeholder="请选择所属公司">
        <el-option v-for="item in organizationListData" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
    </div>
    <div class="list-title" style="padding:5px 10px 8px;background:#f8f8f8;">
      <!-- 条件搜索 -->
      <h3 class="title" style="float:none;border-bottom:1px #ccc solid;margin-bottom:5px;">条件搜索<span class="tip"
          style="font-size:12px;">（搜索条件为选填,
          然后点击搜索按钮进行搜索）</span></h3>
      <section>
        <label class="label-name">物品名称：</label>
        <el-input v-model="form.consumableName" placeholder="物品名称关键字(模糊搜索)" size="small" style="width:170px;"></el-input>
        <div class="r" style="margin-top:3px;">
          <a :href="baseURL+'/storage/material/pan/detail/list/download?depId='+this.form.depId+'&startTime='+this.form.startTime+'&endTime='+this.form.endTime+'&consumableName='+this.form.consumableName+'&accesstoken='+userData.accesstoken"
            style="float:right;position:relative;z-index:2;" target="_blank">
            <el-button type="primary" size="mini">盘点物品明细表下载</el-button>
          </a>
        </div>
        <label class="label-name" style="margin-left:5px;">时间：</label>
        <el-date-picker v-model="form.startTime" size="small" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
          placeholder="开始时间"></el-date-picker><span style="width:30px;display:inline-block;text-align:center">至</span>
        <el-date-picker v-model="form.endTime" size="small" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
          placeholder="结束时间"></el-date-picker>
        <el-button type="success" @click="getLists()" size="mini">搜索</el-button>
      </section>
    </div>

    <el-table :data="paginationData" border style="width: 100%" v-loading="loading">
      <el-table-column prop="name" label="明细名称">
      </el-table-column>
      <el-table-column label="盘点情况" width="100px" align="center">
        <template slot-scope="scope">
          <strong v-if="scope.row.panType=='0'" class="green">盘亏</strong>
          <strong v-if="scope.row.panType=='1'" class="red">盘盈</strong>
        </template>
      </el-table-column>
      <el-table-column prop="amount" label="数量" width="80px" align="center">
      </el-table-column>
      <el-table-column prop="time" label="盘点时间" width="165px">
      </el-table-column>
    </el-table>

    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length"
      @current-change="handleCurrentChange">
    </el-pagination>
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import UserInfo from '@/components/UserInfo'
  import MaterialInDetail from '@/page/storage/components/materialInDetail'
  export default {
    components: {
      UserInfo,
      MaterialInDetail,
    },
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
        managerStorage: state => state.storage.managerStorage,
      })
    },
    data() {
      return {
        baseURL: axios.defaults.baseURL,
        // 编辑盘点单
        // editMaterialInStatus: false,
        form: {
          depId: "",
          startTime: '',
          endTime: '',
          consumableName: '',
          depId: '',
        },

        // 盘点单明细详情
        detailStatus: false,

        organizationListData: [],
        noSelectOrganization: true,
        // 列表
        loading: true,
        pageSize: 20,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],
      }
    },
    created() {
      this.organizationListData = this.organization[0].childDepts
      this.form.depId = this.userData.secDepIds.split(",")[0] / 1

      if (this.userData.secDepIds.split(",")[0] == "7") {
        this.noSelectOrganization = false
      }
    },
    mounted() {},
    methods: {
      // 隐藏详情
      hideDetail() {
        this.detailStatus = false
      },
      // 显示盘点单详情
      ShowMaterialInDetail(row) {
        this.materialInData = row
        this.detailStatus = true
      },
      // 获取仓库列表
      getHouseList() {
        this.houseList = this.managerStorage
        // 获取库存
        this.getLists()
      },
      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选新闻数据
      getFilterData() {
        console.log(this.filterName)
        if (this.filterName) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _new = this.listData[i]
            if (_new.name.indexOf(this.filterName) != -1) {
              this.filterData.push(_new)
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this
          .currentPage)
      },
      // 获取列表
      getLists() {
        ajax.get('/consumable/pan/detail/list', this.form, (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getFilterData()
        })
      },
    },
    watch: {
      "form.depId"() {
        this.form.startTime = ''
        this.form.endTime = ''
        this.form.consumableName = ''
        this.getLists()
      }
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/consumable/InventoryDetailList.vue